import { Component } from 'react';
import { connect } from 'react-redux';
import { signoutUser } from '../../actions';

class Signout extends Component {
  componentWillMount() {
    this.props.signoutUser();
    this.props.history.push('/signin');
  }

  render() {
    return null;
  }
}

export default connect(null, { signoutUser })(Signout);
